import { isOrganizationUid } from "@buildwithflux/models";
/**
 * Simple aggregate repository that either retrieves the user or the organization
 */
export class AccountRepository {
    userRepository;
    organizationRepository;
    userPrivateMetadataRepository;
    organizationPrivateMetadataRepository;
    constructor(userRepository, organizationRepository, userPrivateMetadataRepository, organizationPrivateMetadataRepository) {
        this.userRepository = userRepository;
        this.organizationRepository = organizationRepository;
        this.userPrivateMetadataRepository = userPrivateMetadataRepository;
        this.organizationPrivateMetadataRepository = organizationPrivateMetadataRepository;
    }
    async getByUid(accountUid) {
        if (isOrganizationUid(accountUid)) {
            return this.organizationRepository.getByUid(accountUid);
        }
        else {
            return this.userRepository.getByUid(accountUid);
        }
    }
    async getPrivateMetadataByUid(accountUid) {
        if (isOrganizationUid(accountUid)) {
            return this.organizationPrivateMetadataRepository.getByUid(accountUid);
        }
        else {
            return this.userPrivateMetadataRepository.getForUser(accountUid);
        }
    }
    async createApiKeyId(accountUid) {
        if (isOrganizationUid(accountUid)) {
            return this.organizationPrivateMetadataRepository.createApiKeyId(accountUid);
        }
        else {
            return this.userPrivateMetadataRepository.createApiKeyId(accountUid);
        }
    }
}
//# sourceMappingURL=AccountRepository.js.map